import { types } from 'mobx-state-tree';


const ATTACHMENT_TYPES = {
    OTHER: 'other',
    INCOME: 'income',
};

const AttachmentTypeEnum = types.enumeration('AttachmentType', Object.values(ATTACHMENT_TYPES));

export {
    AttachmentTypeEnum,
};
export default ATTACHMENT_TYPES;
